import { useEffect, useState } from "react";
import { format } from "date-fns";
import axiosInstance from "../../api/axiosInstance";
import Loader from "../../common/Loader";

const FabricatorReport = () => {
  const today = format(new Date(), "yyyy-MM-dd");
  const [fromDate, setFromDate] = useState("2024-01-01");
  const [toDate, setToDate] = useState("2025-12-31");
  const [loading, setLoading] = useState(false);
  const [reportData, setReportData] = useState([]);

  const fetchReport = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.post("Report/GetAllByFabricator", {
        fromDate,
        toDate,
      });
      setReportData(response.data);
    } catch (error) {
      console.error("Failed to fetch report:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchReport();
  }, []);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-xl font-black text-slate-800 uppercase tracking-tight">Fabricator Report</h2>
        <span className="bg-white border border-slate-200 px-4 py-1.5 rounded-full text-[10px] font-black text-slate-500 uppercase tracking-widest shadow-sm">
          {reportData.length} Records Found
        </span>
      </div>

      {/* Filters */}
      <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-100 flex flex-wrap gap-6 items-end">
        <div className="flex-1 min-w-[200px]">
          <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2 block ml-1">From Date</label>
          <input
            type="date"
            value={fromDate}
            onChange={(e) => setFromDate(e.target.value)}
            className="w-full px-4 py-3 bg-slate-50/50 border border-slate-200 rounded-xl text-xs font-bold text-slate-700 focus:outline-none focus:border-primary focus:ring-4 focus:ring-primary/5 transition-all outline-none"
          />
        </div>

        <div className="flex-1 min-w-[200px]">
          <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2 block ml-1">To Date</label>
          <input
            type="date"
            value={toDate}
            onChange={(e) => setToDate(e.target.value)}
            className="w-full px-4 py-3 bg-slate-50/50 border border-slate-200 rounded-xl text-xs font-bold text-slate-700 focus:outline-none focus:border-primary focus:ring-4 focus:ring-primary/5 transition-all outline-none"
          />
        </div>

        <button
          onClick={fetchReport}
          className="px-8 py-3 bg-primary text-white text-[10px] font-black uppercase tracking-widest rounded-xl hover:bg-primary-dark hover:shadow-lg hover:-translate-y-0.5 transition-all active:scale-95 shadow-md shadow-primary/20"
        >
          Search Reports
        </button>
      </div>

      {/* Report Table */}
      {loading ? (
        <div className="min-h-[400px] flex items-center justify-center">
          <Loader />
        </div>
      ) : (
        <div className="bg-white border border-slate-100 rounded-2xl shadow-sm overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-slate-50/50 border-b border-slate-100">
                  <th className="px-6 py-4 text-left text-[10px] font-black text-slate-400 uppercase tracking-widest">Fabricator Name</th>
                  <th className="px-6 py-4 text-left text-[10px] font-black text-slate-400 uppercase tracking-widest">Contact No</th>
                  <th className="px-6 py-4 text-left text-[10px] font-black text-slate-400 uppercase tracking-widest">Email</th>
                  <th className="px-6 py-4 text-left text-[10px] font-black text-slate-400 uppercase tracking-widest">Firm Name</th>
                  <th className="px-6 py-4 text-left text-[10px] font-black text-slate-400 uppercase tracking-widest">Office Address</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-50">
                {reportData.length > 0 ? (
                  reportData.map((item, index) => (
                    <tr key={index} className="hover:bg-slate-50/30 transition-colors group">
                      <td className="px-6 py-4 text-xs font-bold text-slate-700">{item.fabricator_Name}</td>
                      <td className="px-6 py-4 text-xs font-bold text-slate-600 font-mono">{item.contact_No}</td>
                      <td className="px-6 py-4 text-xs font-bold text-primary underline cursor-pointer">{item.email_ID}</td>
                      <td className="px-6 py-4 text-xs font-bold text-slate-600">{item.firm_Name}</td>
                      <td className="px-6 py-4 text-xs font-bold text-slate-600 max-w-xs truncate" title={item.office_Address}>{item.office_Address}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="px-6 py-12 text-center">
                      <div className="flex flex-col items-center justify-center gap-2">
                        <span className="text-4xl">🔍</span>
                        <p className="text-slate-500 text-xs font-bold uppercase tracking-widest">No records found</p>
                        <p className="text-slate-400 text-[10px]">Try adjusting your search criteria</p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default FabricatorReport;
